import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { ListedCancelationReason } from 'contracts/CancelationReasons';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'LIST_CANCELATION_REASONS_',
  }
);

export interface ListCancelationReasonsState {
  data: ListedCancelationReason[];
  loading: boolean;
  errorMessage: string | null;
}

export interface ListCancelationReasonsRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: ListedCancelationReason[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: ListCancelationReasonsState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: ListCancelationReasonsState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: ListCancelationReasonsState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: ListCancelationReasonsState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: ListCancelationReasonsState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const listCancelationReasons = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const ListCancelationReasonsTypes = Types;
export const ListCancelationReasonsActions = Creators;
